/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit DefaultPaymentPlans/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import * as fromFormat from 'Data/format.js'
import * as fromHelpers from '../../helpers.js'
import CaseCloserPaymentPlans from 'DesignSystem/CaseCloserPaymentPlans/index'
import React from 'react'
import TysiaHorizDivider from 'DesignSystem/TysiaHorizDivider/index'
import TysiaIconPlan from 'DesignSystem/Svgs/TysiaIconPlan/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import TysiaTextLink from 'DesignSystem/TysiaTextLink/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function DefaultPaymentPlans({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/Content/TreatmentPlans/Steps/Content/PaymentPlans/Content/Content/PaymentPlan/Content/Content/Send/Content/Sidebar/Content/Overview/DefaultPaymentPlans"
  
}) {
  let flow = fromFlow.useFlow()
  let setFlowTo = fromFlow.useSetFlowTo(viewPath)
let dtSpaceMs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.ms'
        })
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtColorsNeutral200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.200'
        })
let dtSpaceLs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.ls'
        })
let globalCurrentLocationIdValueData = fromData.useDataFormat({ viewPath,
context: 'global',
path: 'current_location._id',
format: fromFormat.asList,
})
let paymentPlanDiscountsValueData = fromData.useDataFormat({ viewPath,
context: 'payment_plan',
path: 'discounts',
format: fromHelpers.getPayorDiscounts,
})
let paymentPlanDiscountsValueData1 = fromData.useDataFormat({ viewPath,
context: 'payment_plan',
path: 'discounts',
format: fromHelpers.getTreatmentDiscounts,
})
let paymentPlanPayors0ShareAmountValueData = fromData.useDataValue({ viewPath,
context: 'payment_plan',
path: 'payors[0].share.amount',
})
let rulesetMaxDiscountValueData = fromData.useDataValue({ viewPath,
context: 'ruleset',
path: 'max_discount',
})
let paymentPlanValueData = fromData.useDataValue({ viewPath,
context: 'payment_plan',
})
let aggregateData = fromHelpers.getMaxDiscount(rulesetMaxDiscountValueData, paymentPlanValueData)
  return (<React.Fragment
>
<div
  data-testid="DefaultPaymentPlans.Horizontal"
  data-view-path={viewPath}
 style={{'--pt-1-I0cQ9': typeof dtSpaceMs === 'number' ? `${dtSpaceMs}px` : dtSpaceMs,'--pb-2-I0cQ9': typeof dtSpaceMs === 'number' ? `${dtSpaceMs}px` : dtSpaceMs,'--pl-3-I0cQ9': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pr-4-I0cQ9': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Horizontal}`}
>
<div
  data-testid="DefaultPaymentPlans.Horizontal:1"
  data-view-path={viewPath}
 style={{'--g-5-I0cQ9': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Horizontal1}`}
>
<TysiaIconPlan
  viewPath={`${viewPath}/TysiaIconPlan`}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size="tiny"
 textTransform="uppercase"
 text="Payment Plans"
/>
</div>
<TysiaTextLink
  viewPath={`${viewPath}/TysiaTextLink`}
 onClick={() => setFlowTo(fromFlow.normalizePath(viewPath, '../../PreviewDefaultPaymentPlans'))}
 isSelected={flow.has(fromFlow.normalizePath(viewPath, '../../PreviewDefaultPaymentPlans'))}
 text="Preview"
/>
</div>
<TysiaHorizDivider
  viewPath={`${viewPath}/TysiaHorizDivider`}
 marginBottom={0}
 marginTop={0}
 backgroundColor={dtColorsNeutral200}
/>
<div
  data-testid="DefaultPaymentPlans.Vertical"
  data-view-path={viewPath}
 style={{'--pt-1-I0cQ9': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs,'--pb-2-I0cQ9': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs,'--pl-3-I0cQ9': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pr-4-I0cQ9': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Vertical}`}
>
<CaseCloserPaymentPlans
  viewPath={`${viewPath}/CaseCloserPaymentPlans`}
 data="global.current_location._id"
 format="/Data/format.js asList"
 organizationIds={globalCurrentLocationIdValueData}
 showMockedOnEmptyPaymentPlans={false}
 data="payment_plan.discounts"
 format="../../helpers.js getPayorDiscounts"
 payorDiscounts={paymentPlanDiscountsValueData}
 data="payment_plan.discounts"
 format="../../helpers.js getTreatmentDiscounts"
 treatmentDiscounts={paymentPlanDiscountsValueData1}
 data="payment_plan.payors[0].share.amount"
 payorShare={paymentPlanPayors0ShareAmountValueData}
 data="ruleset.max_discount"
 data="payment_plan"
 aggregate="../../helpers.js getMaxDiscount"
 maxDiscount={aggregateData}
 showPlanDescription={false}
 showFinalDiscount={false}
/>
</div>
{children}
</React.Fragment>)
}